import useCurrencyConverter from "../../../hooks/useCurrencyConverter";
import { CalculadoraBCVModal } from "./CalculadoraBCVModal";
import { CalculatorIcon } from "./icons";
import "./CalculadoraBCV.scss";

/**
 * Botón flotante (FAB) global que abre la Calculadora BCV.
 * Conecta el hook de negocio con la modal de presentación.
 */
export const FloatingCalculadoraBCV = () => {
  const {
    isOpen,
    openModal,
    closeModal,
    paymentDate,
    handlePaymentDateChange,
    rateFormatted,
    isLoadingRate,
    usdAmount,
    handleUsdAmountChange,
    bsAmountFormatted,
    handleCopyToClipboard,
    copied,
  } = useCurrencyConverter();

  return (
    <>
      <button
        type="button"
        className="bcv-fab"
        onClick={openModal}
        aria-label="Abrir calculadora BCV"
        title="Calculadora BCV"
      >
        <CalculatorIcon width="24" height="24" />
      </button>

      <CalculadoraBCVModal
        isOpen={isOpen}
        onClose={closeModal}
        paymentDate={paymentDate}
        onPaymentDateChange={handlePaymentDateChange}
        rateFormatted={rateFormatted}
        isLoadingRate={isLoadingRate}
        usdAmount={usdAmount}
        onUsdAmountChange={handleUsdAmountChange}
        bsAmountFormatted={bsAmountFormatted}
        onCopy={handleCopyToClipboard}
        copied={copied}
      />
    </>
  );
};

export default FloatingCalculadoraBCV;
